import { render, staticRenderFns } from "./zidongyindaoche.vue?vue&type=template&id=12c82afd&scoped=true"
import script from "./zidongyindaoche.vue?vue&type=script&lang=js"
export * from "./zidongyindaoche.vue?vue&type=script&lang=js"
import style0 from "./zidongyindaoche.vue?vue&type=style&index=0&id=12c82afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c82afd",
  null
  
)

export default component.exports